import React from 'react'
import { ResponsiveSVG } from 'ui/acro'
import StopWatch from '../../images/latest/stopwatch.svg'
import styled from 'styled-components'
import GuideText from './GuideText'
import {
  DifficultyContainer,
  IntensityContainer,
  StyleSection
} from './DifficultyIntensity'

const Main = styled.div``

const formatDuration = (ms) => {
  if (!ms) return '0 min 0 sec'
  const totalSeconds = Math.floor(ms / 1000)

  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60

  return `${minutes} min ${seconds} sec`
}

const PlanBasicInfo = ({ plan_entry }) => {
  const plan = plan_entry.plan
  const diffLevel = plan_entry?.difficultyLevel || plan?.difficultyLevel
  const difficultyLevel = diffLevel ? String(diffLevel).toLowerCase() : ''
  const intensityLevel = plan_entry?.intensityLevel || plan?.intensityLevel

  return (
    <Main className='plan-basic-info'>
      <div className='style-total-section'>
        <StyleSection categories={plan_entry?.categories} />

        <div
          className={`${
            plan?.primaryCategory ? 'basic-row' : 'basic-row basic-row-pushed'
          }`}
        >
          <div className='stat-row'>
            <h4>Total Run Time</h4>
            <div className='plan-stats duration'>
              <div className='icon'>
                <ResponsiveSVG
                  className='codicon'
                  SVG={StopWatch}
                  width='25px'
                  height='25px'
                />
              </div>
              <div className='desc'>
                <span className='total-plan-duration'>
                  {formatDuration(plan_entry?.video?.durationInMs)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='entry-level-info'>
        <div className='diff-row'>
          <DifficultyContainer difficultyLevel={difficultyLevel} />
          <IntensityContainer intensityLevel={intensityLevel} />
        </div>

        {difficultyLevel && intensityLevel && <GuideText />}
      </div>
    </Main>
  )
}

export default PlanBasicInfo
